"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MementoType = void 0;
var MementoType;
(function (MementoType) {
    MementoType["CUSTOMER"] = "customer";
    MementoType["EM"] = "em";
    MementoType["ENGINEEER"] = "engineer";
    MementoType["REGION"] = "region";
    MementoType["TEAM"] = "team";
})(MementoType || (exports.MementoType = MementoType = {}));
//# sourceMappingURL=Memento.js.map